export const DAO_CODE = 'TRAINING_STUDENT_TYPES' + '_DAO';
